import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Box } from "@mui/material";
import Home from  './pages/home/Home'
import OurGames from './pages/ourGames/ourGames';
import NewsBlog from './pages/news_blog/News_Blog';
import AboutUs from './pages/aboutUs/aboutUs';
import ContactUs from './pages/contactUs/contactUs';
import News from './pages/NewsPage/News';
// import Raffle  from "./pages/news_raffle/Raffle";
import Game9SPDetails from './pages/game9SPDetails/game9SPDetails';

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
  },
});

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Box>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/ourGames" element={<OurGames />} />
              <Route path="/news_blog" element={<NewsBlog />} />
              <Route path="/aboutUs" element={<AboutUs />} />
              <Route path="/contactUs" element={<ContactUs />} />
              <Route path="/news/:slug" element={<News />} />
              {/* <Route path="/raffle-rules" element={<Raffle />} /> */}
              <Route path="/game9SPDetails" element={<Game9SPDetails />} />
            </Routes>
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App;
